import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const downloadPatientReportFn = async ({ tenantVal, patientId }) => {
  const axiosInstance = createAxiosInstance();
  const response = await axiosInstance.get(
    `${tenantVal}/pdf/patientreport/patient/${patientId}`,
    { responseType: "blob" }
  );

  const contentDisposition = response.headers?.["content-disposition"] ?? "";
  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
  const filename =
    filenameMatch?.[1] ??
    response.headers?.["file-name"] ??
    `patient-report-${patientId}.pdf`;

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};

export const useDownloadPatientReport = () =>
  useMutation({
    mutationFn: downloadPatientReportFn,
    onError: () => toast.error("Failed to download patient report"),
  });
